import { createRootRoute } from '@tanstack/react-router';
import { createRootLayout } from '@/components/RootLayout';

const { RootComponent, PendingComponent } = createRootLayout('エージェントハブ');

export const Route = createRootRoute({
  component: RootComponent,
  pendingComponent: PendingComponent,
});
